import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { InputGroup, Input, Button } from 'reactstrap';
import '../components/Auth/Auth.css';

const PasswordInput = ({
    inputGroupId = "password-group",
    id = "password",
    showPassword,
    toggleShowPassword,
    password,
    handleInputChange,
    name = "password",
    isUniversalCredits,
    placeholder = "Введите ваш пароль",
    universalPlaceholder = "Используются универсальные данные"
}) => {
    return (
        <InputGroup id={inputGroupId} className="password-group">
            <Input
                className="standard-text form-control"
                type={showPassword ? "text" : "password"}
                id={id}
                name={name}
                placeholder={isUniversalCredits ? universalPlaceholder : placeholder}
                value={password}
                onChange={handleInputChange}
                disabled={isUniversalCredits}
            />
            <Button
                type="button"
                className="password-toggle-btn"
                onClick={toggleShowPassword}
                disabled={isUniversalCredits}>
                {showPassword ? (
                    <FaEyeSlash className="password-eye" size={14} />
                ) : (
                    <FaEye className="password-eye" size={14} />
                )}
            </Button>
        </InputGroup>
    );
};

export default PasswordInput;